import React from "react";
import {useSelector} from "react-redux";
import GUIButton from "../GUIButton";
import avatarHideIcon from "images/mainland/selfie-avatar.png";
import pressAvatarHideIcon from "images/mainland/selfie-avatar_pressed.png";
import "./index.scss";

const AvatarHideButton = ({onClick}) => {
  const isAvatarHidden = useSelector(state => state.selfie.isAvatarHidden);
  return (
    <div className="avatar-hide-button">
      <GUIButton
        imgUrl={isAvatarHidden ? pressAvatarHideIcon : avatarHideIcon}
        onClickFunc={onClick}
      />
    </div>
  );
};

export default AvatarHideButton;
